
import "./CategoryRecyclerview.css";


const CategoryRecyclerview = ({ items, onItemClick }) => {
  return (
    <div className="horizontal-recyclerview">
      {items.map((item, index) => (
        <div
          key={index}
          className="recyclerview-item-cat"
          onClick={() => onItemClick?.(item)}
        >
          <img
            src={`${item.image}`}
            alt={item.name}
          />

          <h5
            style={{
              fontSize: "13px",
              whiteSpace: "normal",
              wordWrap: "break-word",
            }}
          >
            {item.name}
          </h5>
        </div>
      ))}
    </div>
  );
};

export default CategoryRecyclerview;
